import { Table, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React from 'react'

import { VirtuosoMantineTableProps } from './virtuoso-table-sections'

const VirtuosoMantineTable = React.forwardRef<
  HTMLTableElement,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  VirtuosoMantineTableProps<any>
>(({ height, minTableWidth, tableProps, ...props }, ref) => {
  const theme = useMantineTheme()

  const is1080pOrLess = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)

  return (
    <Table
      {...props}
      //style={{ tableLayout: 'fixed', height: `${height} !important` }}
      ref={ref}
      verticalSpacing={is1080pOrLess ? 'xs' : 'md'}
      horizontalSpacing={is1080pOrLess ? 'xs' : 'md'}
      miw={minTableWidth}
      {...tableProps}
    ></Table>
  )
})

VirtuosoMantineTable.displayName = 'VirtuosoMantineTable'
export default VirtuosoMantineTable
